import styled from 'styled-components';

import Skeleton from '@/components/atom/skeleton';

const QnaDetailAnswerCard = () => {
  return (
    <Card>
      <Row>
        <Skeleton style={{ width: 43, height: 43, borderRadius: '50%' }} />
        <Skeleton
          style={{
            width: 100,
            height: 22,
            marginLeft: 8,
          }}
        />
      </Row>
      <Skeleton style={{ height: 1, marginTop: 12, marginBottom: 12 }} />
      <Skeleton style={{ height: 22, marginTop: 20, marginBottom: 4 }} />
      <Skeleton style={{ height: 22, marginBottom: 4 }} />
      <Skeleton style={{ width: '70%', height: 22, marginBottom: 20 }} />
      <Row>
        <Skeleton style={{ width: '100%', height: 38, marginRight: 10 }} />
        <Skeleton style={{ width: '100%', height: 38 }} />
      </Row>
    </Card>
  );
};

const QnaDetailSkeleton = () => {
  return (
    <Container>
      <Top>
        <Row>
          <Skeleton style={{ width: 50, height: 22, marginRight: 4 }} />
          <Skeleton style={{ width: 60, height: 22, marginRight: 4 }} />
          <Skeleton style={{ width: 50, height: 22 }} />
        </Row>
        <Skeleton style={{ height: 24, marginTop: 20, marginBottom: 4 }} />
        <Skeleton style={{ width: '90%', height: 24, marginBottom: 20 }} />
        <Skeleton style={{ height: 22, marginTop: 20, marginBottom: 4 }} />
        <Skeleton style={{ height: 22, marginBottom: 4 }} />
        <Skeleton style={{ width: '70%', height: 22, marginBottom: 20 }} />
        <Skeleton style={{ width: 100, height: 100, marginTop: 20, marginBottom: 4 }} />
        <Skeleton style={{ width: 150, height: 22, marginTop: 20, marginBottom: 20 }} />
        <SpaceRow>
          <Skeleton style={{ width: 50, height: 24 }} />
          <Skeleton style={{ width: 50, height: 24 }} />
        </SpaceRow>
      </Top>
      <Bottom>
        {Array.from({ length: 4 }).map((_, i) => (
          <QnaDetailAnswerCard key={`skeleton_${i}`} />
        ))}
      </Bottom>
    </Container>
  );
};

export default QnaDetailSkeleton;

const Container = styled.div``;
const Row = styled.div`
  display: flex;
  align-items: center;
`;

const Top = styled.div`
  padding: 20px;
`;

const SpaceRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const Bottom = styled.div`
  background: ${({ theme }) => theme.color.gray40};
  padding: 20px;
`;

const Card = styled.div`
  background: ${({ theme }) => theme.color.white};
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 15px;
`;
